
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fatos-relevantes",
      function () {
        return require("private-next-pages/fatos-relevantes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fatos-relevantes"])
      });
    }
  